<template>
    <div class="legal-person-step2" v-loading="pageLoading">
        <el-form ref="formData" class="sr-from-single" label-width="150px" :model="formData">
            <el-form-item prop="name" label="手机号验证">
                <b>{{ userInfo.telephone }}</b>
            </el-form-item>
            <el-form-item label="短信验证码" :rules="[{ required: true, message: '请输入名称' }]">
                <div class="input-with-button">
                    <el-input v-model="formData.smsCode" placeholder="请输入短信验证码"></el-input>
                    <el-button native-type="button" type="text" @click="getSmsCode()" :disabled="smsCode.disabled"
                        :loading="smsCode.loading">
                        {{ smsCode.text }}
                    </el-button>
                </div>
            </el-form-item>
            <el-form-item label="">
                <el-button @click="previousStep()">上一步</el-button>
                <el-button type="primary" :loading="loading" @click="onSubmit">进行认证</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { enterpriseSmsCode, enterpriseSmsCodeCertify, setEnterpriseStep } from '@/api/user';
export default {
    data() {
        return {
            pageLoading: false,
            loading: false,
            formData: {
                smsCode: '',
            },
            smsCode: {
                text: '立即获取',
                disabled: false,
                loading: false,
            },
        };
    },
    computed: {
        userInfo() {
            return this.$store.state && this.$store.state.userInfo;
        },
    },
    methods: {
        async previousStep() {
            const flag = await this.$confirm(`返回后当前页面的信息将不会保存。`, '确定要返回操作吗？');
            if (flag === 'cancel') return;
            const respnose = await setEnterpriseStep(1);
            const { state, msg } = respnose.data;
            if (!state) return this.$message.error(msg || '返回上一步失败，请稍后尝试');
            this.$emit('updateStep');
        },
        async getSmsCode() {
            this.smsCode.loading = true;
            const respnose = await enterpriseSmsCode();
            const { state, msg } = respnose.data;
            this.smsCode.loading = false;
            if (!state) return this.$message.error(msg || '获取数据失败,请重试');
            this.countdown(59);
        },
        countdown(second) {
            this.smsCode.disabled = true;
            const intervalTime = setInterval(() => {
                if (second <= 0) {
                    clearInterval(intervalTime);
                    this.smsCode.disabled = false;
                    return (this.smsCode.text = '立即获取');
                }
                this.smsCode.text = second + 's重新发送';
                second -= 1;
            }, 1000);
        },
        async onSubmit() {
            const valid = await this.$refs['formData'].validate();
            if (!valid) return;
            this.loading = true;
            const respnose = await enterpriseSmsCodeCertify(this.formData.smsCode);
            const { state, msg } = respnose.data;
            this.loading = false;
            this.$emit('updateStep');
            if (!state) return this.$message.error(msg || '获取数据失败,请重试');
        },
    },
};
</script>
<style lang="scss" scoped>
.input-with-button {
    position: relative;
    display: inline-block;

    .el-button {
        position: absolute;
        right: 0;
        top: 0;
        padding: 11px 20px;
    }
}
</style>
